module.exports = __webpack_public_path__ + "static/memory_img5@2x-1ff5d481eb183b243988fb6fbdda2a32.png";